module.exports = __webpack_public_path__ + "img/sign-up.cb5a3b75.jpg";